var __jsx = React.createElement;
import { styled } from '@linaria/react';
import React from 'react';
import { PelotonMark } from '@peloton/icons';
import { white } from '@engage/colors';
import { Spinner, VisuallyHidden } from '@webtv/shared-ui'; // Since this component is used on a statically generated page,
// we have to announce with English until the app is fully loaded

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var loadingCopy = 'loading';
/**
 * Splash Page
 * Design: https://zpl.io/bJWqPPn
 */

export var SplashPage = function SplashPage() {
  var ref = React.useRef();
  React.useEffect(function () {
    // Set focus during first render to prevent garbage a11y announcements
    ref.current && ref.current.focus();
  }, [ref]);
  return /*#__PURE__*/_jsxs(Container, {
    ref: ref,
    tabIndex: -1,
    role: "presentation",
    children: [/*#__PURE__*/_jsx(PelotonMark, {
      fill: white
    }), /*#__PURE__*/_jsx(SpinnerContainer, {
      children: /*#__PURE__*/_jsx(SplashSpinner, {})
    }), /*#__PURE__*/_jsx(VisuallyHidden, {
      children: loadingCopy
    })]
  });
};
var Container = /*#__PURE__*/styled("div")({
  name: "Container",
  class: "c1iw62ee"
});
var SpinnerContainer = /*#__PURE__*/styled("div")({
  name: "SpinnerContainer",
  class: "s1fwipup"
});
var SplashSpinner = /*#__PURE__*/styled(Spinner)({
  name: "SplashSpinner",
  class: "st8c583"
});

require("../../../../apps/tv/.linaria-cache/packages/@webtv/onboarding/ui/SplashPage.linaria.module.css");